export default __webpack_public_path__ + "8901da7eac9652d0a7f2629031567b6b.png";